<template>
  <div class="login-container">
    <div class="login-wrapper">
      <form>
        <h2>Login</h2>
          <div class="input-field">
          <input type="text" required v-model="user.email">
          <label>Enter your email</label>
        </div>
        <div class="input-field">
          <input type="password" required v-model="user.password">
          <label>Enter your password</label>
        </div>
        <!--<button>Log In</button>-->
        <a-button type="primary" :loading="loading" @click="login">Login</a-button>
      </form>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import {Button} from 'ant-design-vue'
  export default {
    components: {
      Button
    },
    methods: {
      login(){
        const self = this
        self.loading = true
        if(self.user.email.trim() == "" || self.user.password.trim() == ""){
          self.loading = false
          self.$notification['error']({
            message: 'Giriş Bilgileri',
            description:
              'Lütfen bilgileri doldurunuz!',
          });
          return
        }
        self.$store.dispatch('LoginUser/loginCall',{
          email: self.user.email,
          password: self.user.password
        }).then((payload) => {
          self.loading = false
          self.$notification['success']({
            message: 'Giriş Başarılı',
            description:
              'Yönlendiriliyorsunuz!',
          });
          const redirect = self.$route.query.redirect || '/admin/overview';
          self.$router.push(redirect)
        }).catch((err) => {
          console.log(err)
          self.loading = false
          if(err.response && err.response.status == 400){
            self.$notification['error']({
              message: 'Giriş Bilgileri',
              description:
                'Lütfen bilgilerinizi kontrol ediniz!',
            });
          }else if(err.response && err.response.status == 404){
            self.$notification['error']({
              message: 'Giriş Bilgileri',
              description:
                'Bilgileriniz hatalı, lütfen bilgilerinizi kontrol ediniz 😊',
            });
          }else{
            self.$notification['error']({
              message: 'Giriş Bilgileri',
              description:
                'Beklenmeyen bir hata oluştu.Lütfen sistem yöneticiniz ile iletişime geçiniz :(',
            });
          }
        });
      }
    },
    data() {
      return {
        loading: false,
        user: {
          email: '',
          password: ''
        }
      }
    }
  }

</script>
